export default __webpack_public_path__ + "static/media/Digital_Quran.ec42743e.svg";